import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import NextRacesControllerImpl from './next-races-controller.js';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * A module responsible for displaying the next races.
 *
 * @class NextRacesController
 * @name NextRaces
 * @memberof Mojito.Modules
 */

/**
 * NextRaces prop types.
 *
 * @property {string} sportId - The id of the sport of interest.
 * @property {string} [applicablePage] - If provided, only promotions that belong to particular page will be presented.
 * @property {string} [title] - The title of the carousel.
 *
 * @memberof Mojito.Modules.NextRaces
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    applicablePage: PropTypes.string,
    title: PropTypes.string,
};

export default UIControllerView('NextRacesController', NextRacesControllerImpl, propTypes);
